import React from 'react';
import { Link, useLocation } from "react-router-dom";

const AppHeader = () => {

  let location = useLocation();

  const getHeight = () => {

    switch (location.pathname) {
      case "/":
        return '70vh';

      default:
        return '45vh';
    }
  }
  return (
    <header id="App-Header" style={{ height: getHeight() }}>

      <Link id="header-szechenyi-img" to="/szechenyi"></Link>


      <nav>
        <ul id="links">
          <li> <Link to="/tevekenysegek">Tevékenységek</Link> </li>
          <li> <Link to="/rolunk">Rólunk</Link> </li>
          <li> <Link to="/szechenyi/energia">Pályázatok</Link> </li>
          <li> <Link to="/kapcsolat">Kapcsolat</Link> </li>
        </ul>
      </nav>

      
      <nav id="logo">
        <Link to="/">Kisújszállási<br />Városgazdálkodási<br />Nonprofit Kft.</Link>
      </nav>

    </header>
  );
};

export default AppHeader;